import { MessageCircle } from 'lucide-react';

export function ArticleCommentsPreview() {
  return (
    <section className="rounded bg-divergent-panel p-4">
      <div className="flex items-center gap-3">
        <div className="grid size-10 place-items-center rounded bg-white/8 text-divergent-yellow">
          <MessageCircle size={20} aria-hidden="true" />
        </div>
        <div>
          <h2 className="font-semibold">Comentarios</h2>
          <p className="text-sm text-white/55">Moderación preparada para conversaciones verificadas.</p>
        </div>
      </div>
    </section>
  );
}
